export default __webpack_public_path__ + "static/media/093-expand-3.b1862c92.png";